import React from 'react';
import './Footer.css';
import pinkFlowers from '../assets/pinkflowers.png';

const Footer = () => {
  return (
    <footer className="footer-section" style={{ backgroundImage: `url(${pinkFlowers})` }}>
      
    </footer>
  );
};

export default Footer;

